import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getChatList, resetChats as apiResetChats, createDefault as apiCreateDefault } from '../../../api';

const ChatList = () => {
    const navigate = useNavigate();
    const [chats, setChats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/');
            return;
        }

        const fetchChats = async () => {
            try {
                setLoading(true);
                setError('');
                const data = await getChatList();
                setChats(data || []);
            } catch (err) {
                setError(err.response?.data?.message || 'Failed to fetch chats.');
                console.error('Error fetching chats:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchChats();
    }, [navigate]);

    const resetChats = async () => {
        try {
            await apiResetChats();
            // window.location.reload();
        } catch (error) {
            console.error('Failed to reset chats:', error);
            alert('Failed to reset chats');
        }
    }

    const createDefault = async () => {
        try {
            await apiCreateDefault();
            // window.location.reload();
        } catch (error) {
            console.error('Failed to create default mates:', error);
            alert('Failed to create default mates');
        }
    }

    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: '#ccdff5',
            padding: '40px 20px'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                background: '#F6F6F6',
                borderRadius: '20px',
                padding: '40px',
                boxShadow: '0 4px 24px rgba(44, 62, 80, 0.08)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '30px'
                }}>
                    <h1 style={{
                        color: '#3c5a5d',
                        margin: 0,
                        fontSize: '2.5rem'
                    }}>
                        Chat List
                    </h1>
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <button
                            onClick={createDefault}
                            style={{
                                padding: '10px 20px',
                                background: '#3c5a5d',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'background 0.2s',
                            }}
                            onMouseEnter={(e) => e.target.style.background = '#2c4345'}
                            onMouseLeave={(e) => e.target.style.background = '#3c5a5d'}
                        >
                            Default mates
                        </button>
                        <button
                            onClick={resetChats}
                            style={{
                                padding: '10px 20px',
                                background: 'transparent',
                                color: '#dc2626',
                                border: '1px solid #dc2626',
                                borderRadius: '8px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = '#dc2626';
                                e.target.style.color = 'white';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = 'transparent';
                                e.target.style.color = '#dc2626';
                            }}
                        >
                            Reset mates
                        </button>
                    </div>
                </div>

                {error && (
                    <div style={{
                        color: '#dc2626',
                        marginBottom: '20px',
                        padding: '12px',
                        background: '#fee2e2',
                        borderRadius: '8px',
                        fontSize: '14px'
                    }}>
                        {error}
                    </div>
                )}

                {loading ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        Loading chats...
                    </div>
                ) : chats.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        No chats found.
                    </div>
                ) : (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                        gap: '24px'
                    }}>
                        {chats.map((chat, index) => (
                            <div
                                key={chat.id || index}
                                onClick={() => navigate(`/chat-details/${chat.id}`)}
                                style={{
                                    background: '#e5eff8',
                                    borderRadius: '16px',
                                    padding: '24px',
                                    border: '1px solid #cfd8dc',
                                    boxShadow: '0 2px 12px rgba(44, 62, 80, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '20px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 12px rgba(44, 62, 80, 0.08)';
                                }}
                            >
                                {chat.mate_avatar?.avatar_link && (
                                    <img 
                                        src={chat.mate_avatar.avatar_link} 
                                        alt={chat.mate_avatar.name}
                                        style={{
                                            width: '80px',
                                            height: '80px',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            border: '3px solid white',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                        }}
                                    />
                                )}
                                <div style={{ flex: 1 }}>
                                    <h3 style={{
                                        color: '#3c5a5d',
                                        marginBottom: '12px',
                                        fontSize: '1.5rem',
                                        fontWeight: '600',
                                        margin: '0 0 8px 0'
                                    }}>
                                        {chat.mate_avatar?.name || `Chat ${index + 1}`}
                                    </h3>
                                    <div style={{
                                        display: 'flex',
                                        gap: '8px',
                                        flexWrap: 'wrap'
                                    }}>
                                        <span style={{
                                            background: '#dbeafe',
                                            color: '#1e40af',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600',
                                        }}>
                                            Status: {chat.chat?.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                        <span style={{
                                            background: '#fef3c7',
                                            color: '#92400e',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600',
                                        }}>
                                            Type: {chat.mate_avatar?.mate_type || 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ChatList;
